import React from 'react';
import { cn } from '@/lib/utils';

interface AvatarProps {
  name?: string | null;
  /** md: 40px (sidebar, rail) · lg: 56px (profile card). */
  size?: 'md' | 'lg';
  className?: string;
}

/** Up to two initials from a name ("Robb Stark" → "RS"). */
const initials = (name?: string | null) =>
  (name ?? '')
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]!.toUpperCase())
    .join('');

/** Circle with the user's initials. */
const Avatar: React.FC<AvatarProps> = ({ name, size = 'md', className }) => (
  <span
    aria-hidden
    className={cn(
      'tw-flex tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-ds-brand-tint tw-font-semibold tw-text-ds-brand-text',
      size === 'md' ? 'tw-h-10 tw-w-10 tw-text-[14px] tw-leading-5' : 'tw-h-14 tw-w-14 tw-text-[20px] tw-leading-7',
      className,
    )}
  >
    {initials(name) || '?'}
  </span>
);

export default Avatar;
